import {schema} from 'normalizr';

export const streamToken = new schema.Entity(
  'stream_token'
);
